import UpshowLogger from '../../Logger';
import { CONTENT_TYPE } from '../../epg/constants/event';

export const BOOT_TEST_FRESHNESS_MS = 4 * 60 * 60 * 1000;

// Boot waits on the live events request, and it has no timeout of its own.
export const LIVE_EVENTS_TIMEOUT_MS = 5000;

function withTimeout (promise, ms) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(`timed out after ${ms}ms`)), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

// No history, bad data or a failed live events lookup all run the test.
export async function shouldRunBootTest ({ lastRunAt, now = Date.now(), fetchLiveEvents }) {
  if (!lastRunAt) return true;

  const lastRunMs = Date.parse(lastRunAt);
  if (Number.isNaN(lastRunMs)) {
    UpshowLogger.warn(['readiness', 'bootGate'], `unparseable last run timestamp ${lastRunAt} — running boot test`);
    return true;
  }

  const elapsedMs = now - lastRunMs;
  if (elapsedMs < 0) {
    UpshowLogger.warn(['readiness', 'bootGate'], `last run timestamp ${lastRunAt} is in the future — running boot test`);
    return true;
  }

  if (elapsedMs < BOOT_TEST_FRESHNESS_MS) {
    UpshowLogger.log(['readiness', 'bootGate'], `last boot test ran at ${lastRunAt} — skipping boot test`);
    return false;
  }

  try {
    const liveEvents = await withTimeout(fetchLiveEvents(), LIVE_EVENTS_TIMEOUT_MS);
    const activeContent = liveEvents && liveEvents.activeLiveContent;
    if (activeContent && activeContent.contentType === CONTENT_TYPE.LIVE_EVENT) {
      UpshowLogger.log(['readiness', 'bootGate'], 'live event active — skipping boot test');
      return false;
    }
  } catch (err) {
    UpshowLogger.error(['readiness', 'bootGate'], 'live events fetch failed — running boot test', err);
  }

  return true;
}
